import React from 'react';
import get from 'lodash.get';
import isNil from 'lodash.isnil';
import getTrcCard from '../../shared/trcSummary/trcContent/trcCards/trcCardsUtils';
import { LABEL } from '../../../../constants/shared/TrcConstants';
import { NOT_SCORED } from '../../../../constants/reading/TroConstants';
import { NA, TITLE } from '../../../../constants/shared/CommonConstants';
import { getBookById, getBookResults } from '../../../../utils/reading/resultReducerHelper';

const { WCPM } = LABEL;

export const writCompLevels = [
    { uid: '0', name: 'Select level', value: null },
    { uid: '2', name: '(Blank)', value: null },
    { uid: '3', name: '0 - No Understanding', value: 0 },
    { uid: '4', name: '1 - Minimal Understanding', value: 1 },
    { uid: '5', name: '2 - General Understanding', value: 2 },
    { uid: '6', name: '3 - Complete Understanding', value: 3 },
];

export const getValueByUid = uid =>
    get(
        writCompLevels.find(level => level.uid === uid),
        'value',
    );

export const getButtons = (onAction, onCancel) => [
    {
        btnClassName: 'dd-button btn-primary',
        iClassName: 'dd-icon icon-amplify-done',
        text: 'Update',
        onClick: value => onAction(getValueByUid(value)),
    },
    {
        btnClassName: 'dd-button btn-secondary',
        iClassName: 'dd-icon icon-amplify-close',
        text: 'Cancel',
        onClick: onCancel,
    },
];

export const getFluencyScoreLabel = fluency => (isNil(fluency) ? NA : `${fluency.score} ${WCPM}`);

export const getFluency = (fluency, isUntranscribable) => (
    <>
        <strong>{!isUntranscribable ? getFluencyScoreLabel(fluency) : NOT_SCORED}</strong>
        <div className="text-right">{`${fluency.fluencyThreshold} ${WCPM}`}</div>
    </>
);

export const getReadingComp = readingComp => {
    const readingCompScore = get(readingComp, 'score', NA);
    return !isNil(readingCompScore) ? readingCompScore : NOT_SCORED;
};

export const getBookByIdFromResult = (result, bookId) =>
    getBookById(getBookResults(result.measureResult), bookId);

export const getTrcCards = (trcSummaryData, summeryLabel = TITLE.SUMMER_TITLE) =>
    trcSummaryData.map(({ period, result }) => getTrcCard(period, result, summeryLabel));
